import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';
import Input, { INPUT_TYPES } from 'components/Kizen/Input';
import { css } from '@emotion/core';

export default styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 20px;
  margin-bottom: 6px;
  h3 {
    margin-top: -1px; // Design nudge
    line-height: 1; // Sidestep bootstrap
  }
  button {
    margin-top: 1px; // Design nudge
    background: none;
    outline: none;
    padding: 0;
    color: var(--color-button-primary-default);
    &:hover {
      color: var(--color-button-primary-hover);
    }
  }
  margin-top: 20px;
  ${({ tall }) =>
    // Most often used with toolbars that contain a search input
    tall &&
    css`
      margin-top: 10px;
      margin-bottom: 5px;
      align-items: center;
      button {
        margin-top: -2px;
      }
    `}
`;

export const CardToolbarSection = styled.div`
  display: flex;
`;

export function CardToolbarTitle(props) {
  return <KizenTypography as="h3" type="subheader" {...props} />;
}

export function CardToolbarButton(props) {
  return (
    <KizenTypography
      as="button"
      weight="bold"
      size="buttonLabel"
      textTransform="uppercase"
      {...props}
    />
  );
}

export const CardToolbarSearch = styled((props) => (
  <Input pill type={INPUT_TYPES.SEARCH} {...props} />
))`
  max-width: 200px;
  &:not(:last-child) {
    margin-right: 15px;
  }
  label {
    margin: 0;
  }
  .input-wrapper {
    margin: 0;
    background-color: var(--color-background-white);
  }
  input {
    min-width: 0;
    padding-right: 0;
  }
`;
